<div class="content-container user-reciever-view__container">
	<section class="data-table clients">
		<header class="data-table__header">
			<h1 class="page-heading">
				<svg width="33" height="43" viewBox="0 0 33 43">
					<path d="M31.263 39.7c0 .597-.487 1.084-1.085 1.084H2.388a1.087 1.087 0 0 1-1.085-1.085V7.593c0-.598.487-1.085 1.085-1.085H6.97c-.004.073-.022.143-.022.217v1.952H4.125a.651.651 0 0 0-.651.651v28.636c0 .359.291.65.651.65h24.316c.36 0 .651-.291.651-.65V9.328c0-.359-.292-.65-.651-.65h-2.823V6.724c0-.074-.017-.144-.021-.217h4.58c.599 0 1.086.487 1.086 1.085v32.106zM10.203 4.772h2.606c.36 0 .652-.292.652-.651a2.825 2.825 0 0 1 2.822-2.82 2.825 2.825 0 0 1 2.822 2.82c0 .359.292.65.652.65h2.605c1.077 0 1.954.876 1.954 1.953v1.952H8.25V6.725c0-1.077.876-1.952 1.954-1.952zM27.79 9.979v27.334H4.776V9.979H27.79zm2.389-4.773h-4.954a3.245 3.245 0 0 0-2.862-1.735h-2.006A4.13 4.13 0 0 0 16.283 0a4.131 4.131 0 0 0-4.074 3.471h-2.005a3.245 3.245 0 0 0-2.862 1.735H2.388A2.39 2.39 0 0 0 0 7.593v32.106a2.39 2.39 0 0 0 2.388 2.386h27.79a2.39 2.39 0 0 0 2.388-2.386V7.593a2.39 2.39 0 0 0-2.388-2.387z"/>
					<path d="M16.283 5.64c.36 0 .651-.291.651-.65V3.254a.651.651 0 0 0-1.302 0V4.99c0 .359.291.65.65.65M14.086 15.81l-3.014 3.011-1.276-1.276a.652.652 0 0 0-.921.921l1.737 1.736a.653.653 0 0 0 .921 0l3.474-3.471a.65.65 0 1 0-.921-.921M14.086 21.884l-3.014 3.011-1.276-1.275a.652.652 0 0 0-.921.92l1.737 1.736a.653.653 0 0 0 .921 0l3.474-3.471a.65.65 0 1 0-.921-.92M14.086 27.958l-3.014 3.011-1.276-1.275a.652.652 0 0 0-.921.92l1.737 1.736a.653.653 0 0 0 .921 0l3.474-3.471a.65.65 0 1 0-.921-.92M21.66 19.09h-.217v-1.952a.651.651 0 0 0-1.303 0v1.952h-.217c-1.272 0-2.388 1.115-2.388 2.387v.262c0 .963.666 1.809 1.656 2.106l2.841.85c.427.127.713.472.713.857v.263c0 .491-.484 1.085-1.085 1.085h-1.718c-.612 0-1.105-.594-1.105-1.085v-.867a.651.651 0 0 0-1.302 0v.867c0 1.271 1.125 2.387 2.407 2.387h.198v1.952a.651.651 0 0 0 1.303 0v-1.952h.217c1.272 0 2.388-1.116 2.388-2.387v-.263c0-.965-.66-1.81-1.642-2.105l-2.84-.85c-.436-.13-.729-.475-.729-.858v-.262c0-.492.485-1.085 1.086-1.085h1.737c.6 0 1.085.593 1.085 1.085v.867a.651.651 0 0 0 1.303 0v-.867c0-1.272-1.116-2.387-2.388-2.387"/>
				</svg>
				<ng-container i18n="@@user.users">Users</ng-container>
			</h1>
		</header>
		
		<div class="data-table__wrap">
			<ng-container *ngIf="['create-user', 'edit-user', 'view-user'].indexOf(activeTab) == -1">
			
				<header class="data-table__create-section">
					<div class="search-field">
						
					</div>
					<div class="create-download">
						<a href="javascript:void(0);" id="create-new-invoice-trigger"  (click)="openAddClientModal()" data-text="X" class="tu-btn pink add-button">
							<svg width="14" height="14" viewBox="0 0 14 14">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
									<path d="M1 7h12M7 1v12"/>
								</g>
							</svg>
							<span i18n="@@common.create_new_user">Create new user</span>
						</a>
					</div>
				</header>
			</ng-container>

			<!-- <ng-template #closeQuote>
				<div class="data-table__btn-wrap w-100">
					<div class="btn-row">
						<a (click)="goToPreviousTab()" href="javascript:void(0)" id="create-new-invoice-trigger" data-text="X" class="tu-btn-circular pink clicked">
							<svg width="14" height="14" viewBox="0 0 14 14">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
									<path d="M1 7h12M7 1v12"/>
								</g>
							</svg>
						</a>
					</div>
				</div>
			</ng-template> -->
		</div>

		<div class="data-table__wrap">				
         	<div class="tab-content data-table__tab-content" id="pills-tabContent">
				<div class="tab-pane fade {{ activeTab == 'all-users' ? 'show active' : ''}}" id="pills-view" role="tabpanel" aria-labelledby="pills-view-tab">
					<teemapp-table
						[name]="'users'"
						[tableSchema]="usersTable"
						[selectable]="false"
						#usersTableRef 
					>
					</teemapp-table>
				</div>
			</div>
		</div>
		
	</section>
</div>